import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

type StatusChipProps = {
  value: 'Active' | 'Inactive' | 'ACTIVE' | 'INACTIVE';
};

const IncActiveInactiveStatusChip = ({ value }: StatusChipProps) => {
  const { t } = useTranslation();

  switch (value) {
    case 'Active':
    case 'ACTIVE':
      return (
        <Chip
          label={t('IncDataGrid.status.active')}
          color="success"
          size="small"
          data-testid="IncActiveInactiveStatusChip"
        />
      );
    case 'Inactive':
    case 'INACTIVE':
      return (
        <Chip
          label={t('IncDataGrid.status.inactive')}
          color="default"
          size="small"
          data-testid="IncActiveInactiveStatusChip"
        />
      );
  }
};

export default IncActiveInactiveStatusChip;
